import { useCallback } from 'react';

import useRest from '@/helper/hooks/useRest';
import { FetchingStatus } from '@/interfaces';

const useResetPasswordAPI = () => {
  const [fetchStatus, error, data, execute] = useRest('/api/auth/reset');

  const isFetching = fetchStatus === FetchingStatus.Fetching;
  const executeAPI = useCallback(
    (values: any) =>
      execute({
        body: JSON.stringify(values),
      }),
    [execute],
  );

  return { fetching: isFetching, error, data, execute: executeAPI };
};

export default useResetPasswordAPI;
